import React, { Component } from 'react';
import Login from './Container/Login';
import Admin from './Container/Admin';
import Client from './Container/Client';
import Errorpage from './Container/Errorpage';
import { BrowserRouter, Switch, Route, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import * as actions from './Store/Actions';
import './App.css';

import Container from '@material-ui/core/Container';
import { authProvider } from './authProvider';
import { AzureAD, AuthenticationState } from 'react-aad-msal';
// import axios from './Helpers/Axiosbase';
class App extends Component {

  state = {
    status: false
  }

  onValidLogin = (acinfo) => {
    this.state.status = true;
    // console.log(JSON.stringify(acinfo));
    this.props.onAuth(acinfo);
  }

  render() {
    let isadmin = this.props.isAdmin;
    return (
      <AzureAD provider={authProvider} forceLogin={true}>
        {
          ({ login, logout, authenticationState, error, accountInfo }) => {
            switch (authenticationState) {
              case AuthenticationState.Authenticated:
                return (
                  <>
                    {!this.state.status ? this.onValidLogin(accountInfo.account) : null}
                    <BrowserRouter>
                      <Switch>
                        <Route exact path="/Client" name="Client Page" component={Client} />
                        <Route exact path="/Admin" name="Admin Page" component={Admin} />
                        {this.props.error!==null?<Route path="/" name="Error Page" component={Errorpage} />:null}
                        {this.props.isAuthenticated ? <Route path="/" component={isadmin.toString() === "true" ? Admin : Client} /> : <Redirect from="/" to="./Login" />}
                      </Switch>
                    </BrowserRouter>

                  </>
                );
              case AuthenticationState.Unauthenticated:
                return (
                  <div>
                    {error && <p><span>An error occured during authentication, please try again!</span></p>}
                    <p>
                      <span>Hey stranger, you look new!</span>
                      <button onClick={login}>Login</button>
                    </p>
                  </div>
                );
              case AuthenticationState.InProgress:
                return (<p>Authenticating...</p>);
              
              default: return (<p>Authenticating...</p>);
            }
          }
        }
      </AzureAD>

    )
  }
}

const mapStateToProps = state => {
  return {
    isAuthenticated: state.auth.userId !== null,
    isAdmin: state.auth.isAdmin,
    error: state.auth.error
  }
}

const mapDispatchToProps = dispatch => {
  return {
    onAuth: (loginValues) => dispatch(actions.auth(loginValues))
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(App);
// export default App;
